import { Box, Button, List, ListItem, TextField, Typography } from "@mui/material";
import { useToastContext } from "components/alert/ToastContext";
import AnexoPanel, { getFormData } from "components/anexo/AnexoPanel";
import Base from "components/Base";
import { Label } from "components/input/Label";
import { useFilter } from "contexts/FilterContext";
import Usuario from "model/administracao/cadastro/Usuario";
import HelpdeskChamado from "model/helpdesk/HelpdeskChamado";
import HelpdeskTramite from "model/helpdesk/HelpdeskTramite";
import Pageable from "model/page/Pageable";
import { DataTableFilterMeta, DataTableStateEvent } from "primereact/datatable";
import { InputTextarea } from "primereact/inputtextarea";
import { useLoadingContext } from "provider/LoadingProvider";
import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import UsuarioService from "service/administracao/cadastro/UsuarioService";
import HelpdeskBatePapoService from "service/helpdesk/HelpdeskBatePapoService";
import HelpdeskChamadoService from "service/helpdesk/HelpdeskChamadoService";
import HelpdeskTramiteService from "service/helpdesk/HelpdeskTramiteService";
import UsuarioLogadoService from "service/usuario/UsuarioLogadoService";
import { converterData, converterDataHora } from "utils/convert";

const usuarioService = new UsuarioService();
const usuarioLogadoService = new UsuarioLogadoService();
const helpdeskBatePapoService = new HelpdeskBatePapoService();
const helpdeskTramiteService = new HelpdeskTramiteService();
const helpdeskChamadoService = new HelpdeskChamadoService();

export default function HelpdeskBatePapoPage() {
    const [tramites, setTramites] = useState<HelpdeskTramite[]>([]);
    const [chamado, setChamado] = useState<HelpdeskChamado>(new HelpdeskChamado());
    const [helpdeskTramite, setHelpdeskTramite] = useState<HelpdeskTramite>(new HelpdeskTramite());
    const [anexos, setAnexos] = useState<any[]>([]);
    const [panelCollapsedAnexos, setPanelCollapsedAnexos] = useState<boolean>(false);
    const [usuario, setUsuario] = useState<Usuario>(new Usuario());
    const { msgAlerta, msgSucesso, msgErro } = useToastContext();
    const [filtrando, setFiltrando] = useState<boolean>(false);
    const [rows, setRows] = useState<HelpdeskChamado[]>([]);
    const [pageable, setPageable] = useState(new Pageable(0, 10, "id,DESC", 0));
    const [totalElements, setTotalElements] = useState<number>(0);
    const { control, setFocus, clearErrors, setError, register, formState: { errors } } = useForm();
    const { startLoading, stopLoading } = useLoadingContext();

    const idChamado = parseInt(window.location.pathname.substring(`/helpdeskBatePapo/`.length))

    useEffect(() => {

        usuarioService.consultar(usuarioLogadoService.getUsuario().id).then(usu => {
            setUsuario(usu);
        });
        helpdeskChamadoService.consultar(idChamado).then(data => {
            setChamado(data);
        })
    }, []);

    useEffect(() => {
        console.log(tramites);
    }, [tramites]);

    useEffect(() => {
        pesquisar();
    }, [pageable]);

    const handleScroll = (e: React.UIEvent<HTMLDivElement>) => {
        const { scrollTop, scrollHeight, clientHeight, } = e.currentTarget;
        if (scrollTop === 0) {
            setPageable((prev) => ({
                ...prev,
                size: 10,
            }));
        }
        if (clientHeight - scrollTop >= scrollHeight) {
            setPageable((prev) => ({
                ...prev,
                size: prev.size + 10
            }));
        }
    };

    useEffect(() => {
    }, []);

    const filterContext = useFilter();
    const screen = "meusChamados";

    const pesquisar = () => {
        helpdeskBatePapoService
        .pesquisar(idChamado, pageable)
        .then(lista => {
            setFiltrando(false);
            setRows(lista.content);
            setTotalElements(lista.totalElements);
            setTramites(lista.content);
        })
        .catch(err => {
            setFiltrando(false);
        });
    };

    return (
        <>
            <Base tituloPagina="Chat" >
                <Box display="flex" flexDirection="column" height="100vh" p={2}>
                    <Box
                        flex={1}
                        overflow="auto"
                        mb={2}
                        onScroll={handleScroll}
                        sx={{ display: "flex", flexDirection: "column-reverse" }}
                    >
                        <List>
                            {[...tramites].reverse().map((tramite: HelpdeskTramite) => (
                                <ListItem
                                    key={tramite.id}
                                    alignItems="flex-start"
                                    sx={{
                                        justifyContent: tramite.usuario.id === usuario.id ? "flex-end" : "flex-start",
                                        textAlign: tramite.usuario.id === usuario.id ? "right" : "left",
                                    }}
                                >
                                    <Box
                                        sx={{
                                            maxWidth: "70%",
                                            bgcolor: tramite.usuario.id === usuario.id ? "#d1e7dd" : "#f8f9fa",
                                            p: 2,
                                            borderRadius: 2,
                                        }}
                                    >
                                        <Typography variant="subtitle2" sx={{ fontSize: '1.25em' }}>{tramite.usuario.nome + ":"}</Typography>
                                        <Typography variant="body2" sx={{ fontSize: '1.25em' }}>{tramite.resposta}</Typography>
                                        <div>
                                            {tramite.arquivos?.map((arquivo) => (
                                                <Typography
                                                    key={arquivo.id}
                                                    component="a"
                                                    href={arquivo.url}
                                                    target="_blank"
                                                    rel="noopener noreferrer"
                                                >
                                                    {arquivo.nome}
                                                </Typography>
                                            ))}
                                        </div>
                                        <Typography variant="caption">{converterDataHora(tramite.data) || ""}</Typography>
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Box>
                    <div className="row">
                        <Label className="col col-sm-12">Mensagem</Label>
                        <div className="col-sm-12">
                            <InputTextarea value={helpdeskTramite.resposta || ""} style={{ width: '100%' }}
                                className={errors.resposta ? "p-invalid" : ""}
                                {...register("resposta", {
                                    onChange: (e) => {
                                        setHelpdeskTramite({ ...helpdeskTramite, resposta: e.target.value })
                                        clearErrors("resposta")
                                    }
                                })} />
                        </div>
                        {errors.resposta && errors.resposta.message ? <span className='col-sm-12' style={{ color: "red" }} >{errors.resposta?.message as string}</span> : null}
                    </div>
                    <div className="row">
                        <div className="col-sm-12">
                            <AnexoPanel
                                novosAnexos={anexos} onChangeNovosAnexos={(e: any) => setAnexos(e)}
                                arquivos={helpdeskTramite.arquivos} onChange={(e) => {
                                    setHelpdeskTramite({ ...helpdeskTramite, arquivos: e })
                                }}
                                collapsed={panelCollapsedAnexos} onToggle={(e) => setPanelCollapsedAnexos(e.value)}
                            />
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-sm-12" style={{ textAlign: 'right', whiteSpace: 'nowrap' }}>
                            <Button variant="contained" color="primary" onClick={() => {
                                startLoading();
                                let helpdeskTramiteLocal = {...helpdeskTramite,
                                    chamado: chamado,
                                }
                                helpdeskTramiteService.gerar(getFormData("helpdeskTramite", helpdeskTramiteLocal, anexos)).then(() => {
                                    stopLoading();
                                    setHelpdeskTramite(new HelpdeskTramite());
                                    setAnexos([]);
                                }).catch(e => {
                                    stopLoading();
                                    console.error(e);
                                    if (e && e.data && e.data.message) {
                                        msgErro("Trâmite", e.data.message);
                                    } else {
                                        msgErro("Trâmite", 'Ocorreu um erro ao gerar o Trâmite, tente novamente!');
                                    }
                                }).finally(()=>{
                                    pesquisar();
                                })
                            }}>
                                Enviar
                            </Button>
                        </div>
                    </div>
                    {anexos.length > 0 && (
                        <Box mt={1}>
                            {anexos.map((file, index) => (
                                <Typography key={index}>{file.name}</Typography>
                            ))}
                        </Box>
                    )}
                </Box>
            </Base>
        </>
    )
}
